import {createApp} from 'vue'
import App from './App.vue'
import router from "./router";

import * as Sentry from "@sentry/vue";
const app = createApp(App);
Sentry.init({
    app,
    dsn: "https://147c548126e1e50f5d06857596e004a1@o360728.ingest.us.sentry.io/4510706793840640",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
});
app.use(router);
app.mount('#app');
